export default __webpack_public_path__ + "static/media/5osiaep1.6a573ea3.webp";